import { render } from "./PopupContact.vue?vue&type=template&id=4d137b5c"
import script from "./PopupContact.vue?vue&type=script&lang=js"
export * from "./PopupContact.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhifangxu/Documents/workspace.nosync/9teacher/code/3staudent_cli/3student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__